<template>
  <div>
    <v-btn
      color="primary"
      small
      @click="abrirDialogPeriodo()"
    >
      <v-icon>mdi-plus</v-icon>
      Novo
    </v-btn>

    <SysDialogFullScreen
      v-model="open_dialog_sazonalidade_produtos"
      :titulo="tituloDinamico"
      @click:hidden-dialog="fechar()"
    >
      <template #titulo-parte-direita>
        <v-btn
          dark
          color="primary"
          :disabled="desserts_direita.length > 0 ? false : true"
          @click="proximo"
        >
          Próximo
        </v-btn>
      </template>

      <sys-fornecedor-autocomplete
        v-model="ids_fornecedores"
        label="Fornecedor"
        outlined
        clearable
        multiple
        dense
        class="mt-2 ml-2 mb-n4"
        style="max-width: 550px"
        desativarSelecionarTodos
        :qtdeVisivelSelecionados="10"
      ></sys-fornecedor-autocomplete>

      <div class="d-flex">
        <div class="width-50-perc">
          <sys-data-table
            v-model="produtos_selecionados_esquerda"
            :headers="headers"
            :items="desserts_esquerda"
            :items-per-page="-1"
            :search="pesquisar_esquerda"
            item-key="idproduto"
            hide-default-footer
            :fixed-header="true"
            show-select
            dense
            :height="alturaDaJanela - 190"
            :item-height="50"
            class="table-full-screen elevation-1"
          >
            <template #top>
              <v-toolbar flat color="white">
                <v-toolbar-title class="ml-n3">
                  Lista de Produtos por Fornecedor
                </v-toolbar-title>

                <v-divider class="mx-5" inset vertical></v-divider>

                <v-spacer></v-spacer>

                <v-text-field
                  v-model="pesquisar_esquerda"
                  placeholder="Pesquisar"
                  hide-details
                  append-icon="mdi-magnify"
                  dense
                  height="25"
                  style="max-width: 350px"
                ></v-text-field>
              </v-toolbar>
            </template>

            <template #item.acoes="{ item }">
              <v-btn
                icon
                @click="adicionarProdutos([item])"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </template>
          </sys-data-table>
        </div>

        <div style="width: 90px" class="d-flex align-center justify-center">
          <div id="div-sazonalidade-icones-add-ou-remove">
            <v-badge bordered color="white" overlap offset-x="45">
              <template #badge>
                <span style="color: #000000">{{ produtos_selecionados_esquerda.length }}</span>
              </template>

              <v-btn
                icon
                outlined
                @click="adicionarProdutos(produtos_selecionados_esquerda)"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-badge>

            <br />

            <v-badge bordered color="white" overlap class="mt-6">
              <template #badge>
                <span style="color: #000000">{{ produtos_selecionados_direita.length }}</span>
              </template>

              <v-btn
                icon
                outlined
                @click="removerProdutos(produtos_selecionados_direita)"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </v-badge>
          </div>
        </div>

        <div class="width-50-perc">
          <sys-data-table
            v-model="produtos_selecionados_direita"
            :headers="headers"
            :items="desserts_direita"
            :items-per-page="-1"
            :search="pesquisar_direita"
            item-key="idproduto"
            hide-default-footer
            :fixed-header="true"
            show-select
            dense
            :height="alturaDaJanela - 190"
            :item-height="50"
            class="table-full-screen elevation-1"
          >
            <template #top>
              <v-toolbar flat color="white">
                <v-toolbar-title class="ml-n3">
                  Lista de Produtos para Sazonalidade
                </v-toolbar-title>

                <v-divider class="mx-5" inset vertical></v-divider>

                <v-spacer></v-spacer>

                <v-text-field
                  v-model="pesquisar_direita"
                  placeholder="Pesquisar"
                  hide-details
                  append-icon="mdi-magnify"
                  dense
                  height="25"
                  style="max-width: 350px"
                ></v-text-field>
              </v-toolbar>
            </template>

            <template #item.acoes="{item}">
              <v-btn
                icon
                @click="removerProdutos([item])"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </template>
          </sys-data-table>
        </div>
      </div>
    </SysDialogFullScreen>

    <CadastroProdutoPeriodoSazonal
      :dialog="open_dialog_sazonalidade_periodo"
      :produtos="desserts_direita"
      :ids_fornecedores="ids_fornecedores"
      :produto_selecionado_sigle="countDesserts.dados"
      @fechar-dialog-editando="emitsDialogPeriodo($event)"
      @reset-cadastro-sazonalidade="fechar()"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Responsividade from '../../../../helpers/ResponsiveHeight';
import SazonalidadeAPI from "../../../../api/sazonalidade";
import CadastroProdutoPeriodoSazonal from "./CadastroProdutoPeriodoSazonal.vue";
import SysDialogFullScreen from "../../../padraoDeLayout/SysDialogFullScreen.vue";
import SysFornecedorAutocomplete from "../../../utils/crud/SysFornecedorAutocomplete.vue";

export default {
  mixins: [Responsividade],
  components: {
    SysDialogFullScreen,
    CadastroProdutoPeriodoSazonal,
    SysFornecedorAutocomplete
  },
  props:{
    openDialogNovaSazonalidade: {
      type: Boolean,
      default: false
    },
    countDesserts: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      open_dialog_sazonalidade_produtos: false,
      open_dialog_sazonalidade_periodo: false,
      ids_fornecedores: [],
      headers : [
        { text: 'ID Produto', value: 'idproduto', style: { width: '50px'} },
        { text: 'Descrição', value: 'descricao_produto', style: { width: '500px'} },
        { text: 'Ações', value: 'acoes', style: { width: '50px'} }
      ],
      produtos_selecionados_esquerda: [],
      desserts_esquerda: [],
      pesquisar_esquerda: "",
      produtos_selecionados_direita: [],
      pesquisar_direita: "",
      desserts_direita: [],
    }
  },
  computed: {
    ...mapGetters({
      grupo_id: "usuario/getGrupoCompras",
      getFornecedor: "fornecedor/getFornecedor",
      produtosSelecionadosVuex: "ProdutosSelecionados/getProdutosSelecionados",
      qtdeProdutosSelecionadosVuex: "ProdutosSelecionados/getQtdeProdutosSelecionados"
    }),
    tituloDinamico() {
      if (this.editando && this.editedItem.filial) {
        return 'Edição de Produto Sazonal - Filial ' + this.editedItem.filial;
      } else if (this.editando) {
        return 'Edição de Produto Sazonal';
      } else if (this.qtdeProdutosSelecionadosVuex > 0) {
        return 'Atualizar Produtos Sazonais';
      } else {
        return 'Cadastro de Produto Sazonal';
      }
    },
  },
  watch: {
    openDialogNovaSazonalidade(val) {
      this.open_dialog_sazonalidade_produtos = val;

      if (val) {
        this.ids_fornecedores = [this.getFornecedor.id];
        this.desserts_direita = this.produtosSelecionadosVuex.map(function(f) { return {idproduto: f.idproduto, descricao_produto: f.descricao_produto}});
        this.open_dialog_sazonalidade_periodo = this.desserts_direita.length > 0 ? true : false;
      }
    },
    ids_fornecedores() {
      this.produtosPorFornecedor();
    }
  },
  methods: {
    fechar() {
      this.$emit('fechar-dialog-nova-sazonalidade');
      this.open_dialog_sazonalidade_produtos = false;
      this.desserts_direita = [];
      this.produtos_selecionados_direita = [];
      this.desserts_esquerda = [];
      this.produtos_selecionados_esquerda = [];
      this.ids_fornecedores = [];
      this.pesquisar_direita = "";
      this.pesquisar_esquerda = "";
    },

    emitsDialogPeriodo(event) {
      setTimeout(() => {
        this.open_dialog_sazonalidade_periodo = false;
        if (event) {
          this.$emit('atualizar-data-table');
        }
      }, 1000);
    },

    abrirDialogPeriodo() {
      if (this.$route.path == '/compra') {
        this.ids_fornecedores = [this.getFornecedor.id];
      }
      this.open_dialog_sazonalidade_produtos = true
    },

    proximo() {
      this.open_dialog_sazonalidade_periodo = true;
    },

    produtosPorFornecedor() {
      if (this.ids_fornecedores.length === 0) {
        return;
      }

      const headers = this.Helpers.iniciarRequisicao()
      const params = {
        fornecedores: this.ids_fornecedores
      }

      this.$store.dispatch("loading/addRequisicao",
        SazonalidadeAPI.produtosPorFornecedor(headers, params)
          .then(response => {
            const {token, produtos} = response.data;

            localStorage.token = token;
            this.desserts_esquerda = produtos;
          })
          .catch(() => this.Helpers.logout())
      )
    },

    adicionarProdutos(itens) {
      if (itens.length === 0) {
        return;
      }

      itens.forEach(el => {
        if (!this.desserts_direita.includes(el)) {

          this.desserts_esquerda = this.desserts_esquerda.filter(function(item) {
            return item.idproduto != el.idproduto;
          });

          if (this.desserts_direita.map((it) => it.idproduto == el.idproduto)[0]) {
            return ;
          }

          this.desserts_direita.push(el);
          this.produtos_selecionados_esquerda = [];
        }
      });
    },

    removerProdutos(itens) {
      if (itens.length === 0) {
        return;
      }

      itens.forEach(el => {
        if (!this.desserts_esquerda.includes(el)) {

          this.desserts_direita = this.desserts_direita.filter(function(item) {
            return item.idproduto != el.idproduto;
          });

          if (this.desserts_esquerda.map((it) => it.idproduto == el.idproduto)[0]) {
            return ;
          }

          this.desserts_esquerda.push(el);
          this.produtos_selecionados_direita = [];
        }
      });
    }
  }
}
</script>

<style scoped>
.width-50-perc {
  width: 50%;
}
#div-sazonalidade-icones-add-ou-remove {
  border: 1px solid rgba(0,0,0,.1);
  border-radius: 25px;
  background: rgba(0,0,0,.02);
  padding: 14px 10px 14px 10px;
}
</style>
